export default "__VITE_ASSET__CDImom4U__"